import { ExportHistoryTranslations } from "./export-history-pt-br";

export const EXPORT_HISTORY_ES_ES: ExportHistoryTranslations = {
	title: "Planillas exportadas",
	subtitle: "Historial de las últimas exportaciones realizadas",
	noExports: "No se encontraron exportaciones",
	noExportsDescription:
		"Sus informes exportados estarán disponibles aquí por 7 días para descargar o reenviar por correo electrónico.",
	columns: {
		date: "Fecha/Hora",
		user: "Usuario",
		status: "Estado",
		email: "Correo electrónico",
		actions: "Acciones",
		fileName: "Planilla",
	},
	status: {
		success: "Éxito",
		pending: "Procesando",
		error: "Error",
	},
	actions: {
		download: "Descargar",
		resend: "Reenviar",
		viewDetails: "Ver detalles",
		retry: "Intentar de nuevo",
	},
	tooltips: {
		processing:
			"Estamos procesando su solicitud.\nEn breve, el informe estará disponible para descargarlo",
		error: "Error al procesar su solicitud.",
		download: "Descargar informe",
		resend: "Reenviar informe",
	},
	messages: {
		resendSuccess: "Planilla reenviada con éxito!",
		resendError: "Error al reenviar planilla",
		downloadError: "Error al descargar planilla",
		loading: "Cargando...",
		loadError: "Error al cargar historial de exportaciones",
	},
	drawer: {
		title: "Planillas Exportadas",
		description:
			"Aquí están las exportaciones de los últimos 7 días. Puede descargar o reenviar al mismo correo electrónico registrado.",
		close: "Cerrar",
	},
	exportButton: {
		export: "Exportar",
		exportEmail: "Exportar al e-mail",
		viewHistory: "Planillas Exportadas",
	},
	reportTitle: "Relatorio de {{startDate}} a {{endDate}}",
	exportedAt: "Exportado {{date}} a las {{time}}",
	to: "Para:",
};
